var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',[_c('div',{staticClass:"th-box"},[_c('span',{staticClass:"th-text ellipsis",attrs:{"data-original-title":""}},[_vm._t("default"),_vm._v("\n      "+_vm._s(_vm.displayName)+"\n    ")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }